import React from 'react';
import { IntakeForm } from './components/IntakeForm';
export function App() {
  return <main className="min-h-screen bg-slate-50 selection:bg-minerva/20 selection:text-navy" data-id="element-0">
      <IntakeForm data-id="element-1" />
    </main>;
}